import { useEffect, useCallback, useState } from 'react';

import { HOT_KEYS } from './constants';

export const useHotKeys = () => {
    const [storedKeys, setStoredKeys] = useState([]);

    const handleKeyDown = useCallback((event) => {
        let triggeredHotkey;

        if (storedKeys.includes(event.keyCode)) {
            return;
        }

        const pressedKeys = [...storedKeys, event.keyCode];

        setStoredKeys(pressedKeys);

        const result = HOT_KEYS.some((element) => {
            const keys = element.hotKey.split(':');

            triggeredHotkey = element.eventName;

            return keys.every((key) => pressedKeys.includes(parseInt(key)));
        });

        if (result) {
            const customEvent = new Event(triggeredHotkey);

            document.dispatchEvent(customEvent);
        }

    }, [storedKeys, setStoredKeys]);

    const handleKeyUp = useCallback(() => setStoredKeys([]), [setStoredKeys]);

    useEffect(() => {
        document.addEventListener('keyup', handleKeyUp);
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keyup', handleKeyUp);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyUp, handleKeyDown]);
};
